import GridOnIcon from '@mui/icons-material/GridOn';
import {
  Button,
} from '@mui/material';
import { CSVLink } from 'react-csv';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './CsvTableExport.scss';

/**
 * A component for blocking user interaction on the screen
 */
const defaultProps = {
  config: [],
  tableData: [],
  className: '',
  linkComponent: <Button className='btn-primary' startIcon={<GridOnIcon />} variant='contained'>CSV</Button>,
};

export default function CsvTableExport(props) {
  const {
    config,
    tableData,
    linkComponent,
    className,
    ...rest
  } = { ...defaultProps, ...filterUndefined(props) };
  const headers = config.map((c) => ({
    label: c.title,
    key: c.dataField,
  }));

  const data = tableData.map((t) => {
    const object = {};
    config.forEach((c) => {
      const { dataRenderer, skipDataRenderForReport } = c;
      object[c.dataField] = dataRenderer && !skipDataRenderForReport ? dataRenderer(t) : String(t[c.dataField]);
    });

    return object;
  });

  return (
    <CSVLink
      {...rest}
      headers={headers}
      data={data}
      className={`csv-table-export ${className}`}
      data-test='csv-export'
      tabIndex={-1}
    >
      {linkComponent}
    </CSVLink>
  );
}
